import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';

const styles = theme => ({
  dialogActions: {
    padding: '16px 24px',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class EntryPupilNoteContentDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isNew: !props.note,
      note: props.note || '',
      // This allows us to check if we should make XHR requests
      originalNote: props.note || '',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleNoteChange = this.handleNoteChange.bind(this);
    this.handleClearText = this.handleClearText.bind(this);
  }

  onSubmit() {
    const note = this.state.note = this.state.note.trim();
    if (note !== this.state.originalNote) {
      this.props.onSubmit(note);
    }
    this.props.onDialogClose();
  }

  handleNoteChange(event) {
    this.setState({
      note: event.target.value,
    });
  }

  handleClearText() {
    this.setState({
      note: '',
    });
  }

  render() {
    const {
      classes,
      isDialogOpen,
      onDialogClose,
      timetableEntryName,
      t,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        disableBackdropClick={true}
        className="timetable-entry-pupil-note-content-dialog"
      >
        <form onSubmit={this.onSubmit}>
          <DialogTitle>{appType === 'student'
            ? t('Your note for {{- timetableEntryName}}', {timetableEntryName})
            : t('Pupil note for {{- timetableEntryName}}', {timetableEntryName})
          }</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id="pupilnote"
              label={t('Note')}
              value={this.state.note}
              placeholder={t('Enter your note here')}
              multiline
              fullWidth
              onChange={this.handleNoteChange}
              variant="outlined"
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              color="secondary"
              onClick={this.handleClearText}
              className="entry-pupil-note-content-dialog-clear-button"
            >
              {t('Clear Text')}
            </Button>
            <div style={{ flex: '1 0 0' }} />
            <Button
              onClick={onDialogClose}
              className="entry-pupil-note-content-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
            <Button
              onClick={this.onSubmit}
              variant="contained"
              color="secondary"
              className="entry-pupil-note-content-dialog-save-button"
            >
              {t('Save Note')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withTranslation()(EntryPupilNoteContentDialog));

